import React from "react";
import Form from "containers/Form";
import Field from "containers/Field";
import { FormLayout } from "playground/cms/Form";
import { EntryDescription } from "../Entries";
import { Property, PropertyGrid } from "playground/cms/fields/Properties";
import DatePicker from "playground/cms/fields/DatePicker";
//import PropTypes from 'prop-types';

export function ReviewForm(props) {
    const { type, id } = props;
    return (
        <FormLayout.Fieldset pad>
            <EntryDescription {...props} />
            <PropertyGrid>
                <Property label={"Źródło"}>
                    <Field
                        id="source"
                        type={"select"}
                        fieldType={"select"}
                        source={"schema:data.source"}
                        nullable={true}
                        variant={"dense"}
                    />
                </Property>
                <Property label={"Ocena"}>
                    <Field id="score" type={"text"} variant={"dense"} />
                </Property>
                <Property label={"Imię"}>
                    <Field id="name" type={"text"} variant={"dense"} />
                </Property>
                <Property label={"Miejscowość"}>
                    <Field id="city" type={"text"} variant={"dense"} />
                </Property>
                <Property label={"Wiek autora"}>
                    <Field id="author_age" type={"text"} variant={"dense"} />
                </Property>
                <Property label={"Data"}>
                    <Field
                        id={"date"}
                        FieldComponent={DatePicker}
                        label={"Wybierz datę"}
                        nullable={true}
                        className={"cols gap-xs"}
                    />
                </Property>
            </PropertyGrid>
            <Field id="external_id" type={"text"} label={"External id"} />
        </FormLayout.Fieldset>
    );
}

ReviewForm.propTypes = {};

ReviewForm.defaultProps = {};

export default ReviewForm;
